module.exports = __webpack_public_path__ + "static/media/profile.40e50129.svg";